import dayjs from 'dayjs';
import { ECalendarEventType } from 'src/components/Calendar/Calendar.interface';

import { IScheduleEvent } from '../CalendarView.interface';
import { CalendarEvent } from '../eventContentSidebar/EventContentSidebar.interface';

export const canShowDeleteButton = (event: IScheduleEvent) => {
  let isVisible = false;

  if (event.extendedProps?.eventType === ECalendarEventType.scheduleComponent) {
    isVisible = true;
  }

  return isVisible;
};

// Delete button is always enabled as per current requirements.
// Keeping canDeleteScheduleBundle for potential future business logic.
export const canDeleteScheduleBundle = (event: IScheduleEvent) => {
  let canDelete = false;

  if (!isScheduleRunning(event.start, event.end)) {
    canDelete = true;
  }

  return canDelete;
};

export const isScheduleRunning = (startDate?: string, endDate?: string) => {
  const now = dayjs();
  const scheduleStartAt = startDate ? dayjs(startDate) : null;
  const scheduleEndAt = endDate ? dayjs(endDate) : null;

  if (scheduleStartAt && scheduleEndAt) {
    return now.isAfter(scheduleStartAt) && now.isBefore(scheduleEndAt);
  }

  if (scheduleStartAt && !scheduleEndAt) {
    return now.isAfter(scheduleStartAt);
  }

  return false;
};

export const isEventSelected = (
  event: IScheduleEvent,
  selectedEvent?: CalendarEvent,
) => {
  if (!event || !selectedEvent) return false;

  if (selectedEvent.eventType === ECalendarEventType.scheduleComponent) {
    return event.extendedProps.scheduleId === selectedEvent.scheduleId;
  }

  if (selectedEvent.eventType === ECalendarEventType.defaultAssembly) {
    return event.extendedProps.assemblyId === selectedEvent.assemblyId;
  }

  return false;
};
